import React from 'react'
import { capitalize, join, words } from 'lodash'
import { Route, Link } from 'react-router-dom'
import { Row } from 'react-bootstrap'

const BreadcrumbsItem = ({ match, title, ...rest }) =>  {
  let itemWords = words(match.url)
  const label = capitalize(join(itemWords, ' '))

  return (<span>
      { match.isExact ? <li className={match.isExact ? 'active' : undefined}>{title || label}</li>
      : <li className={match.isExact ? 'active' : undefined}>
          <Link to={match.url || ''}>
              {label}
          </Link>
      </li>}
      <Route path={`${match.url}/:path`} render={props => (
        <BreadcrumbsItem title={title} {...props} />
      )}/>
    </span>
  )
}

export default class Breadcrumbs extends React.Component {

  render() {
    return <Row>
      <ol className='breadcrumb'>
        <li><Link to=''>Home</Link></li>
        <Route path='/:path' render={props => (
          <BreadcrumbsItem title={this.props.title} {...props} />
        )}/>
      </ol>
    </Row>
  }
}
